import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AppointmentFlowService } from '../services/appointment-flow.service';
import { AppointmentService, IAppointmentDetails } from '../services/appointment.service';
import { IFilteredTimeslots } from '../models/appointments.models';

@Component({
  selector: 'open-appointment-flow',
  templateUrl: './appointment-flow.component.html',
  styleUrls: ['./appointment-flow.component.scss'],
})
export class AppointmentFlowComponent implements OnInit {
  formData!: any;
  userDetails!: any;
  availableTimeslots!: any;
  private navigationSubscription!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public appointmentFlowService: AppointmentFlowService,
    private appointementService: AppointmentService
  ) {}

  ngOnInit() {
    if (this.route.snapshot.data.availableTimeslots) {
      this.availableTimeslots = this.route.snapshot.data.availableTimeslots;
    } else {
      // no Snapshot data provided, redirecting to Support Flow to get required appointment details
      this.router.navigate(['/support']);
    }

    if (this.route.snapshot.data.userDetails) {
      const { first_name, last_name, email, mobile, partner, slug } = this.route.snapshot.data.userDetails;

      this.userDetails = {
        first_name,
        last_name,
        email,
        phone: mobile,
        partner_slug: partner.slug,
        user_slug: slug
      };
    }

    if (!this.formData) {
      this.formData = this.appointmentFlowService.getFirstStep(this.availableTimeslots, this.userDetails);
    }

    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.appointementService.details = {} as IAppointmentDetails;
        this.appointmentFlowService.availableTimeslots = [] as IFilteredTimeslots[];
      }
    });
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
